var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(!_vm.isWx)?_c('top-header',{attrs:{"type":6,"placeholder":_vm.lsName,"textColor":"#000","bgColor":"#fff","fontSize":"0.32rem"}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.lsInfo)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }